import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { Button, Content, Alert } from 'ui'
import { clearSession } from '../session/actions'
import { useDispatch } from 'react-redux'

export const SessionExpiredView: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleReturn = () => {
    // Reset the session invalidation flag before redirecting
    dispatch(clearSession({ invalidSession: false }))
    navigate('/login', { replace: true })
  }

  return (
    <>
      <Helmet>
        <title>Session Expired - MCSS PRO Connect</title>
      </Helmet>
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="max-w-md w-full px-6 py-8 bg-white shadow-md rounded-lg">
          <Alert.Dismissable
            title="Your session has expired"
            className="mb-6"
            variant="error"
          >
            <p className="text-sm">
              For security reasons, your session has expired or is no longer
              valid.
            </p>
          </Alert.Dismissable>

          <Content.Body className="mb-6">
            Please log in again to continue using MCSS PRO Connect. Your unsaved
            changes may have been lost.
          </Content.Body>

          <div className="flex justify-center">
            <Button onClick={handleReturn} className="px-6">
              Return to Login
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
